



































































































































































interface RegisterRequest {
  fullName: string;
  username: string;
  email: string;
  phoneNumber: string;
  password: string;
  confirmPassword: string;
  referralCode: string;
  dialCode: string;
  countryCode: string;
  country: string;
  dob: string;
}

interface IPhoneNumberInput {
  countryCallingCode: string;
  nationalNumber: string;
  number: string;
  country: ICountry;
  countryCode: string;
  valid: boolean;
  formatted: string;
}

interface ICountry {
  name: string;
  iso2: string;
  dialCode: string;
}

import { Component, Vue } from "vue-property-decorator";
import { authService } from "../api/authentication/authentication.api";

@Component
export default class SignUp extends Vue {
  payload: Partial<RegisterRequest> = {
    dob: "1999-01-01"
  };
  phoneNumber: string = "";

  errors?: any;

  get errorsMap() {
    return new Map(this.errors.items.map((error: any) => [error.field, error.message]));
  }

  handlePhoneInput(options: IPhoneNumberInput) {
    this.payload.phoneNumber = options?.nationalNumber;
    this.payload.dialCode = options?.countryCallingCode;
    this.payload.countryCode = options?.countryCode;
    this.payload.country = options?.country?.name;
  }

  async handle(payload: Partial<RegisterRequest>) {
    try {
      await this.validate();
      this.isLoading = true;
      await authService.register(payload);
      const hash = this.makeOTPScreenPayload({
        identifiers: [payload.phoneNumber as string],
        verifyAccount: true,
        routeName: "MainApp"
      });
      return this.$router.push({ name: "OTPScreen", params: { hash } });
    } catch (error) {
      this.handleError(error);
    } finally {
      this.isLoading = false;
    }
  }
}
